<template>
  <article>
    <section class="xbed-sub-title">
      <span>订单来源</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>订单管理</BreadcrumbItem>
        <BreadcrumbItem>订单来源</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <section style="margin-top:20px">
      <Form :model="search" inline>
        <FormItem label="渠道性质：" :label-width="110">
          <Select v-model="search.filter.sourceType" filterable>
            <Option :value="-1">全部</Option>
            <Option :value="1">自有渠道</Option>
            <Option :value="2">OTA渠道</Option>
            <Option :value="3">业主渠道</Option>
            <Option :value="4">酒店前台</Option>
          </Select>
        </FormItem>
        <FormItem label="状态：" :label-width="84">
          <Select v-model="search.filter.status" filterable>
            <Option :value="-1">全部</Option>
            <Option :value="1">启用</Option>
            <Option :value="0">停用</Option>
          </Select>
        </FormItem>
        <FormItem label="是否代下单：" :label-width="100">
          <Select v-model="search.filter.isShow" filterable>
            <Option :value="-1">全部</Option>
            <Option :value="1">是</Option>
            <Option :value="0">否</Option>
          </Select>
        </FormItem>
        <br>
        <FormItem label="关键字查询：" :label-width="105">
          <Input v-model="search.filter.search" placeholder="请输入关键字查询"></Input>
        </FormItem>
        <FormItem :label-width="53">
          <Button type="primary" @click="conditionSearch">查询</Button>
        </FormItem>
        <FormItem :label-width="10">
          <Button type="primary" @click="addNewResouceBtn">新增来源</Button>
        </FormItem>
      </Form>
      <br>
      <Table stripe :columns="column" :data="order.list"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="order.count" :current="order.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
    </section>
    <Modal ref="newResourceModal" :loading="true" v-model="newResource.modal" :title="operate == 'edit' ? '编辑来源' : '新增来源'" @on-cancel="cancel" @on-ok="subNewResource" width="800">
        <Form ref="resourceBasicInfo" :rules="resourceValidate" :model="newResource.formData">
          <FormItem v-if="operate == 'edit'" label="渠道ID" :label-width="105" prop="id">
            <span>{{newResource.formData.id}}</span>
          </FormItem>
          <FormItem label="渠道名称" :label-width="105" prop="name">
            <Input v-model="newResource.formData.name"></Input>
          </FormItem>
          <FormItem label="渠道性质" :label-width="105">
            <RadioGroup v-model="newResource.formData.sourceType">
              <Radio label="1" >自有渠道</Radio>
              <Radio label="2" >OTA渠道</Radio>
              <Radio label="3" >业主渠道</Radio>
              <Radio label="4" >酒店前台</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="状态" :label-width="105">
            <Select v-model="newResource.formData.status">
              <Option value="1">启用</Option>
              <Option value="0">停用</Option>
            </Select>
          </FormItem>
          <FormItem label="是否代下单" :label-width="105">
            <Select v-model="newResource.formData.isShow">
              <Option value="1">是</Option>
              <Option value="0">否</Option>
            </Select>
          </FormItem>
          <FormItem label="创建支付状态" :label-width="105">
            <RadioGroup v-model="newResource.formData.createPayStatus">
              <Radio label="0" >未支付</Radio>
              <Radio label="1" >已支付</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="短租押金" :label-width="105">
            <Select v-model="newResource.formData.needShortGuarentee">
              <Option value="1">收</Option>
              <Option value="0">不收</Option>
            </Select>
          </FormItem>
          <FormItem label="发票设置" :label-width="105">
            <Select v-model="newResource.formData.invoceConfig">
              <Option value="1">必须开票</Option>
              <Option value="2">选择开票</Option>
            </Select>
          </FormItem>
          <FormItem label="自动检测对象" :label-width="105">
            <Input v-model="newResource.formData.autoObject"></Input>
          </FormItem>
          <FormItem label="备注" :label-width="105">
            <Input v-model="newResource.formData.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" :maxlength="255" placeholder=""></Input>
          </FormItem>
        </Form>
        <h6>代下单金额设置</h6>
        <Form ref="resourceInfo" :rules="resourceValidate" :model="newResource.formData.expression" class="resource-info">
          <FormItem label="金额对应关系提示" :label-width="130">
            <Checkbox v-model="newResource.formData.priceRelationState">开启</Checkbox>
            <Button type="primary" style="margin-left: 50px;" @click="amountTips.modal = true">设置提示</Button>
          </FormItem>
          <b class="tips-b">xbed房间原价 orderPrice</b>
          <FormItem prop="salePrice.formula">
            <Row>
              <Col span="6" class="item-tit">
                <span class="sp">渠道售价</span>
                <span class="sp">salePrice</span>
              </Col>
              <Col span="3">
                <Select v-model="newResource.formData.expression.salePrice.type">
                  <Option :value="1">固定</Option>
                  <Option :value="2">填写</Option>
                </Select>
              </Col>
              <Col span="2" class="type-col">
                <span>{{newResource.formData.expression.salePrice.type === 1 ? '固定' : '默认'}}=</span>
              </Col>
              <Col span="11">
                <Input v-model="newResource.formData.expression.salePrice.formula" @on-keyup="trimInput('salePrice')" ref="salePrice"></Input>
              </Col>
            </Row>
          </FormItem>
          <FormItem prop="channelDiscount.formula">
            <Row>
              <Col span="6" class="item-tit">
                <span class="sp">渠道优惠</span>
                <span class="sp">channelDiscount</span>
              </Col>
              <Col span="3">
                <Select v-model="newResource.formData.expression.channelDiscount.type">
                  <Option :value="1">固定</Option>
                  <Option :value="2">填写</Option>
                </Select>
              </Col>
              <Col span="2" class="type-col">
                <span>{{newResource.formData.expression.channelDiscount.type === 1 ? '固定' : '默认'}}=</span>
              </Col>
              <Col span="11">
                <Input v-model="newResource.formData.expression.channelDiscount.formula" @on-keyup="trimInput('channelDiscount')" ref="channelDiscount"></Input>
              </Col>
            </Row>
          </FormItem>
          <FormItem prop="discount.formula">
            <Row>
              <Col span="6" class="item-tit">
                <span class="sp">总优惠</span>
                <span class="sp">discount</span>
              </Col>
              <Col span="3">
                <Select v-model="newResource.formData.expression.discount.type">
                  <Option :value="1">固定</Option>
                  <Option :value="2">填写</Option>
                </Select>
              </Col>
              <Col span="2" class="type-col">
                <span>{{newResource.formData.expression.discount.type === 1 ? '固定' : '默认'}}=</span>
              </Col>
              <Col span="11">
                <Input v-model="newResource.formData.expression.discount.formula" @on-keyup="trimInput('discount')" ref="discount"></Input>
              </Col>
            </Row>
          </FormItem>
          <FormItem prop="realPrice.formula">
            <Row>
              <Col span="6" class="item-tit">
                <span class="sp">客人应付</span>
                <span class="sp">realPrice</span>
              </Col>
              <Col span="3">
                <Select v-model="newResource.formData.expression.realPrice.type">
                  <Option :value="1">固定</Option>
                  <Option :value="2">填写</Option>
                </Select>
              </Col>
              <Col span="2" class="type-col">
                <span>{{newResource.formData.expression.realPrice.type === 1 ? '固定' : '默认'}}=</span>
              </Col>
              <Col span="11">
                <Input v-model="newResource.formData.expression.realPrice.formula" @on-keyup="trimInput('realPrice')" ref="realPrice"></Input>
              </Col>
            </Row>
          </FormItem>
          <!-- <FormItem prop="userPay.formula">
            <Row>
              <Col span="6" class="item-tit">
                <span class="sp">客人实付</span>
                <span class="sp">userPay</span>
              </Col>
              <Col span="3">
                <Select v-model="newResource.formData.expression.userPay.type">
                  <Option :value="1">固定</Option>
                  <Option :value="2">填写</Option>
                </Select>
              </Col>
              <Col span="2" class="type-col">
                <span>{{newResource.formData.expression.userPay.type === 1 ? '固定' : '默认'}}=</span>
              </Col>
              <Col span="11">
                <Input v-model="newResource.formData.expression.userPay.formula" @on-keyup="trimInput('userPay')" ref="userPay"></Input>
              </Col>
            </Row>
          </FormItem> -->
          <FormItem prop="channelCommission.formula">
            <Row>
              <Col span="6" class="item-tit">
                <span class="sp">OTA佣金</span>
                <span class="sp">channelCommission</span>
              </Col>
              <Col span="3">
                <Select v-model="newResource.formData.expression.channelCommission.type">
                  <Option :value="1">固定</Option>
                  <Option :value="2">填写</Option>
                </Select>
              </Col>
              <Col span="2" class="type-col">
                <span>{{newResource.formData.expression.channelCommission.type === 1 ? '固定' : '默认'}}=</span>
              </Col>
              <Col span="11">
                <Input v-model="newResource.formData.expression.channelCommission.formula" @on-keyup="trimInput('channelCommission')" ref="channelCommission"></Input>
              </Col>
            </Row>
          </FormItem>
          <!-- <FormItem prop="otherChannelExpenses.formula">
            <Row>
              <Col span="6" class="item-tit">
                <span class="sp">渠道活动费</span>
                <span class="sp">otherChannelExpenses</span>
              </Col>
              <Col span="3">
                <Select v-model="newResource.formData.expression.otherChannelExpenses.type">
                  <Option :value="1">固定</Option>
                  <Option :value="2">填写</Option>
                </Select>
              </Col>
              <Col span="2" class="type-col">
                <span>{{newResource.formData.expression.otherChannelExpenses.type === 1 ? '固定' : '默认'}}=</span>
              </Col>
              <Col span="11">
                <Input v-model="newResource.formData.expression.otherChannelExpenses.formula" @on-keyup="trimInput('otherChannelExpenses')" ref="otherChannelExpenses"></Input>
              </Col>
            </Row>
          </FormItem> -->
          <FormItem prop="receivedPrice.formula">
            <Row>
              <Col span="6" class="item-tit">
                <span class="sp">xbed实收</span>
                <span class="sp">receivedPrice</span>
              </Col>
              <Col span="3">
                <Select v-model="newResource.formData.expression.receivedPrice.type">
                  <Option :value="1">固定</Option>
                  <Option :value="2">填写</Option>
                </Select>
              </Col>
              <Col span="2" class="type-col">
                <span>{{newResource.formData.expression.receivedPrice.type === 1 ? '固定' : '默认'}}=</span>
              </Col>
              <Col span="11">
                <Input v-model="newResource.formData.expression.receivedPrice.formula" @on-keyup="trimInput('receivedPrice')" ref="receivedPrice"></Input>
              </Col>
            </Row>
          </FormItem>
          <FormItem prop="invoicePrice.formula">
            <Row>
              <Col span="6" class="item-tit">
                <span class="sp">发票金额</span>
                <span class="sp">invoicePrice</span>
              </Col>
              <Col span="3">
                <Select v-model="newResource.formData.expression.invoicePrice.type">
                  <Option :value="1">固定</Option>
                  <Option :value="2">填写</Option>
                </Select>
              </Col>
              <Col span="2" class="type-col">
                <span>{{newResource.formData.expression.invoicePrice.type === 1 ? '固定' : '默认'}}=</span>
              </Col>
              <Col span="11">
                <Input v-model="newResource.formData.expression.invoicePrice.formula" @on-keyup="trimInput('invoicePrice')" ref="invoicePrice"></Input>
              </Col>
            </Row>
          </FormItem>
        </Form>
    </Modal>
    <!-- 渠道金额对应关系提示 -->
    <Modal v-model="amountTips.modal" title="渠道金额对应关系提示" width="635" ok-text="保存" :closable="false">
      <p style="color: red;margin-bottom: 24px;">填入渠道后台对应的金额文案，留空即“系统自动计算”</p>
      <Form inline>
        <FormItem label="渠道售价=" :label-width="115">
          <Input v-model.trim="amountTips.priceRelationDetail.salePrice" clearable :maxlength="20"></Input>
        </FormItem>
        <FormItem label="渠道优惠=" :label-width="115">
          <Input v-model.trim="amountTips.priceRelationDetail.channelDiscount" clearable :maxlength="20"></Input>
        </FormItem>
        <FormItem label="OTA佣金=" :label-width="115">
          <Input v-model.trim="amountTips.priceRelationDetail.channelCommission" clearable :maxlength="20"></Input>
        </FormItem>
        <FormItem label="发票金额=" :label-width="115">
          <Input v-model.trim="amountTips.priceRelationDetail.invoicePrice" clearable :maxlength="20"></Input>
        </FormItem>
        <FormItem label="客人应付=" :label-width="115">
          <Input v-model.trim="amountTips.priceRelationDetail.userRealPay" clearable :maxlength="20"></Input>
        </FormItem>
        <FormItem label="xbed实收=" :label-width="115">
          <Input v-model.trim="amountTips.priceRelationDetail.receivedPrice" clearable :maxlength="20"></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Moment from "moment";
import Utils from "../../utils";
//import Config from "../../config";
import API from "../../api";
//import {STORE_KEY} from "../../constants";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'Right': this.token,
      // 'group': 'dev' // 本地请求才需要加该参数
    }
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryOrderResouceList();
  },
  data() {
    return {
      isSubmit: false,
      operate:"add",//edit
      search:{
        page:1,
        rows:10,
        filter:{
          sourceType: -1,
          status: -1,
          isShow: -1,
          search: ""
        },
        sort:"id",
        asc:0
      },
      order:{
        list:[],
        page:1,
        pageSize:10,
        count:0
      },
      column: [
        {
          title: "ID",
          key: "id",
          align: "center",
          width: 80,
        },
        {
          title: "订单来源",
          key: "name",
          align: "center",
          width: 150
        },
        {
          title: "状态",
          width: 100,
          align: "center",
          render: (h, params) => {
            let statusStr = params.row.status == 1 ? '启用' : '停用';
            return h("div", {}, statusStr);
          }
        },
        {
          title: "是否代下单",
          width: 120,
          align: "center",
          render: (h, params) => {
            let statusStr = params.row.isShow == 1 ? '是' : '否';
            return h("div", {}, statusStr);
          }
        },
        {
          title: "渠道性质",
          key: "taxpayerId",
          width: 200,
          align: "center",
          render: (h, params) => {
            let statusStr = (
              params.row.sourceType == 1 ? '自有渠道' :
              params.row.sourceType == 2 ? 'OTA渠道' :
              params.row.sourceType == 3 ? '业主渠道' :
              '酒店前台' 
            )
            return h('div',{},statusStr)
          }
        },
        {
          title: "备注",
          key: "remark",
          width: 200,
          align: "center",
        },
        {
          title: "创建时间",
          key: "createdAt",
          width: 200,
          align: "center",
          render: (h, params) => {
            let createdAt = Moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss');
            return h("div", {}, createdAt);
          }
        },
        {
          title: "最后修改",
          key: "updatedAt",
          width: 200,
          align: "center",
          render: (h, params) => {
            let updatedAt = `${params.row.updatedAt ? Moment(params.row.updatedAt).format('YYYY-MM-DD HH:mm:ss') : Moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss')} | ${params.row.updatedBy || ''}`;
            return h("div", {}, updatedAt);
          }
        },
        {
          title: "操作",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("Button", {
                props: {
                  type: "primary",
                  size: "small"
                },
                style: {
                  margin: "5px"
                },
                on: {
                  click: () => {
                    this.openModal(params);
                  }
                }
              },
              '编辑')
          }
        }
      ],
      newResource: {
        modal: false,
        formData:{
          name: "",
          updatedBy: '',
          sourceType: "1",
          createPayStatus: '0',
          isShow: "1",
          status: "1",
          remark: "",
          needShortGuarentee: "1",
          tip: "Xbed设置的房间售价",
          invoceConfig: "1",
          autoObject: '',
          priceRelationState: false,
          expression: {
            salePrice: {
              formula: '',
              type: 1
            },
            channelDiscount: {
              formula: '',
              type: 1
            },
            discount: {
              formula: '',
              type: 1
            },
            realPrice: {
              formula: '',
              type: 1
            },
            // userPay: {
            //   formula: 0,
            //   type: 1
            // },
            channelCommission: {
              formula: '',
              type: 1
            },
            // otherChannelExpenses: {
            //   formula: '',
            //   type: 1
            // },
            receivedPrice: {
              formula: '',
              type: 1
            },
            invoicePrice: {
              formula: '',
              type: 1
            }
          }
        }
      },
      resourceValidate: {
        name: [
          {required: true, message:'渠道名称不能为空', trigger: 'blur'},
        ],
        'salePrice.formula': [
          {required: true, message: '请填写金额', trigger: 'blur'}
        ],
        'channelDiscount.formula': [
          {required: true, message: '请填写金额', trigger: 'blur'}
        ],
        'discount.formula': [
          {required: true, message: '请填写金额', trigger: 'blur'}
        ],
        'realPrice.formula': [
          {required: true, message: '请填写金额', trigger: 'blur'}
        ],
        // 'userPay.formula': [
        //   {required: true, message: '请填写金额', trigger: 'blur'}
        // ],
        'receivedPrice.formula': [
          {required: true, message: '请填写金额', trigger: 'blur'}
        ],
        'invoicePrice.formula': [
          {required: true, message: '请填写金额', trigger: 'blur'}
        ],
        'channelCommission.formula': [
          {required: true, message: '请填写金额', trigger: 'blur'}
        ],
        // 'otherChannelExpenses.formula': [
        //   {required: true, message: '请填写金额', trigger: 'blur'}
        // ],
        // bargainMoney: [
        //   {required: true, message: '请填写押金', trigger: 'blur'}
        // ]
      },
      editResource: {
        modal: false
      },
      amountTips: {
        modal: false,
        priceRelationDetail: {
          salePrice: "",
          channelDiscount: "",
          userRealPay: "",
          channelCommission: "",
          receivedPrice: "",
          invoicePrice: ""
        },
      }
    };
  },
  methods: {
    changePage(pageIndex) {
      this.search.page = pageIndex;
      this.queryOrderResouceList();
    },
    changePageSize(pageSize) {
      this.search.page = 1;
      this.search.rows = pageSize;
      this.queryOrderResouceList();
    },
    addNewResouceBtn() {
      this.operate = "add";
      this.newResource.modal = true;
    },
    async subNewResource() {
      this.$refs.newResourceModal.buttonLoading = false;
      this.validateResource('resourceBasicInfo');
      this.isSubmit && (this.validateResource('resourceInfo'));
      if(this.isSubmit){
        this.addNewResource();
        //this.newResource.modal = false;
      }
    },
    validateResource(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.isSubmit =  true;
        } else {
          this.isSubmit =  false;
        }
      })
    },
    resetNewResource() {
      this.newResource.formData.id && (delete this.newResource.formData.id);
      this.newResource.formData.name = "";
      this.newResource.formData.remark = "";
      this.newResource.formData.sourceType = "1";
      this.newResource.formData.isShow = "1";
      this.newResource.formData.createPayStatus = "0";
      this.newResource.formData.invoceConfig = "1";
      this.newResource.formData.status = "1";
      this.newResource.formData.autoObject = "";
      this.newResource.formData.needShortGuarentee = "1";
      this.newResource.formData.tip = "Xbed设置的房间售价";
      this.newResource.formData.priceRelationState = false;
      for(let key in this.newResource.formData.expression){
        this.newResource.formData.expression[key].formula = ''
        this.newResource.formData.expression[key].type = 1
      }
      for (let key2 in this.amountTips.priceRelationDetail) {
        this.amountTips.priceRelationDetail[key2] = ''
      }
      this.$refs.resourceBasicInfo.resetFields()
      this.$refs.resourceInfo.resetFields()
    },
    async addNewResource() {
      this.$refs.newResourceModal.buttonLoading = true;
      let params = Object.assign({},this.newResource.formData);
      params.expression = JSON.stringify(params.expression);
      params.updatedBy = this.username;
      params.priceRelationState = params.priceRelationState ? 1 : 0;
      params['priceRelationDetail'] = JSON.stringify(this.amountTips.priceRelationDetail)
      // if (params.priceRelationState) {
      //   params['priceRelationDetail'] = JSON.stringify(this.amountTips.priceRelationDetail)
      // }
      let resp;
      if(this.operate==="add"){
        resp = (await API.omsAPI[this.env].clientServer.addOrderSourceAli(
          params,
          this.protHeaders
        )).data;
      }else{
        resp = (await API.omsAPI[this.env].clientServer.editOrderSourceAli(
          params,
          this.protHeaders
        )).data;
      }
      this.$refs.newResourceModal.buttonLoading = false;
      if (resp.retCode) {
        // 错误警告
        this.$Notice.error({
          title: "操作失败",
          desc: resp.retsmsg
        });
        return
      }
      this.$Notice.success({
        title: this.operate==="add" ? "新增成功" : "修改成功"
      });
      this.newResource.modal = false;
      this.queryOrderResouceList();
      this.resetNewResource();
    },
    async queryOrderResouceList() {
      let filter = Object.assign({}, this.search.filter);
      for(var key in filter){
        if(filter[key]==-1){
          filter[key] = ""
        }
      }
      let resp = (await API.omsAPI[this.env].clientServer.getPageOrderSource({
        page: this.search.page,
        size: this.search.rows,
        sort: 'desc',
        orderBy: 'id',
        search: filter
      }, this.protHeaders)).data;

      if (resp.retCode) {
        // 错误警告
        this.showNotice('error', resp.msg)
        this.$refs.invoiceAtRedModal.buttonLoading = false;
      }
      this.order.list = resp.content;
      this.order.count = resp.total;
    },
    conditionSearch() {
      this.search.page = 1;
      this.queryOrderResouceList();
    },
    openModal(params) {
      let obj = params.row;
      Object.keys(this.newResource.formData).forEach((value) => {
        if(obj[value]!=undefined){
          if (value === 'priceRelationState') {
            this.newResource.formData['priceRelationState'] = obj['priceRelationState'] ? true : false
            if (obj['priceRelationDetail']) {
              this.amountTips.priceRelationDetail = JSON.parse(obj['priceRelationDetail'])
            }
          } else if (typeof obj[value]=="number"){
            this.newResource.formData[value] = String(obj[value]);
          } else {
            this.newResource.formData[value] = obj[value];
          } 
        }
      });
      this.newResource.formData.expression = JSON.parse(this.newResource.formData.expression);
      this.newResource.formData.id = obj.id;
      this.newResource.modal = true;
      this.operate = "edit";
    },
    cancel() { 
      this.resetNewResource();
    },
    // 过滤输入框的空格
    trimInput(key) {
      if (this.$refs[key]) {
        // 匹配空格
        if ((/^ +| +$/g).test(this.$refs[key].value)) 
          this.newResource.formData.expression[key].formula = this.newResource.formData.expression[key].formula.trim()
        
        if ((/^-/).test(this.$refs[key].value)) 
          this.newResource.formData.expression[key].formula = ''  
        
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.resource-info {
  .tips-b {
    display: block;
    font-size: 14px;
    margin: 0 0 20px 25px;
  }
  .item-tit {
    margin-right: 12px;
    .sp {
      display: block;
      line-height: 18px;
      font-size: 14px;
      text-align: right;
      &:first-child:before{
        content: '*';
        display: inline-block;
        color: red;
        margin-right: 4px;
      }
    }
  }
  .type-col {
    font-size: 14px;
    text-align: right;
    margin-left: 10px;
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order-resource.vue